export function safeInvokeNoArg<T>(func: () => T): T | null {
  try {
    return func?.();
  } catch (e) {
    console.error('[@zoom/hybrid-jssdk] safeInvokeNoArg error', e);
    console.trace('safeInvokeNoArg trace');
    return null;
  }
}

export function safeInvoke<T, Args extends any[]>(
  func: (...args: Args) => T,
  ...args: Args
): T | null {
  try {
    return func(...args);
  } catch (e) {
    console.error('[@zoom/hybrid-jssdk] safeInvoke error', e);
    console.trace('safeInvoke trace');
    return null;
  }
}
